import { Component } from '@angular/core'

@Component({
  selector: 'hs-router',
  template: `<router-outlet></router-outlet>`,
})
export class RouterComponent {}
